import React, { Component } from "react";
import { Slide } from "react-awesome-reveal";
import Particles from "../../Background/Particles";
import type { ResumeData } from "../../types/resume";

interface ResumeProps {
  data?: ResumeData;
}

class Resume extends Component<ResumeProps> {
  getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    if (!this.props.data) return null;

    const skillmessage = this.props.data.skillmessage;
    const education = this.props.data.education.map((edu) => (
      <div key={edu.school} className="mb-6">
        <h3 className="text-xl text-white font-semibold">{edu.school}</h3>
        <p className="info text-gray-300">
          {edu.degree} <span>&bull;</span> <em>{edu.graduated}</em>
        </p>
        <p className="text-gray-400">{edu.description}</p>
      </div>
    ));

    const work = this.props.data.work.map((job) => (
      <div key={job.company} className="mb-6">
        <h3 className="text-xl text-white font-semibold">{job.company}</h3>
        <p className="info text-gray-300">
          {job.title} <span>&bull;</span> <em>{job.years}</em>
        </p>
        <p className="text-gray-400">{job.description}</p>
      </div>
    ));

    const skills = this.props.data.skills.map((skill) => {
      const backgroundColor = this.getRandomColor();
      const width = skill.level;
      return (
        <li key={skill.name} className="mb-3">
          <em className="text-white text-semibold font-bold">{skill.name}</em>
          <span
            style={{ width, backgroundColor }}
            className="block h-3 rounded-lg"
          ></span>
        </li>
      );
    });

    return (
      <section id="resume" className="relative z-10 px-6 py-20 md:px-12">
        {/* Background Particles */}
        <div className="absolute top-0 left-0 w-full h-full">
          <Particles
            particleColors={["#ffffff"]}
            particleCount={60}
            particleSpread={25}
            speed={0.05}
            particleBaseSize={32}
            alphaParticles={false}
            disableRotation={true}
            pixelRatio={1}
          />
        </div>

        {/* Education */}
        <Slide direction="left" duration={1300}>
          <div className="mb-16">
            <h1 className="text-4xl font-bold text-white mb-6">Education</h1>
            {education}
          </div>
        </Slide>

        {/* Work */}
        <Slide direction="left" duration={1300}>
          <div className="mb-16">
            <h1 className="text-4xl font-bold text-white mb-6">Work</h1>
            {work}
          </div>
        </Slide>

        {/* Skills */}
        <Slide direction="left" duration={1300}>
          <div>
            <h1 className="text-4xl font-bold text-white mb-6">Skills</h1>
            <p className="text-gray-300 mb-6">{skillmessage}</p>
            <ul className="space-y-4">{skills}</ul>
          </div>
        </Slide>
      </section>
    );
  }
}

export default Resume;
